import { serverGet, serverPost } from "utility";

class UserService {
  gets({ onFinish = () => {} }) {
   serverGet({
    url: "user/all",
    onFinish: onFinish
   }) 
  }
  create({data = {}, onFinish = () => {}}) {
    serverPost({
      url: "user/register",
      data: {
        firstName: data?.firstName ?? "",
        lastName: data?.lastName ?? "",
        email: data?.email ?? "",
        phone: data?.phone ?? "",
        password: data?.password ?? "",
        role: data?.role ?? "0",
        birthday: data?.birthday ?? "",
        confirm_code: data?.confirm_code ?? 0,
        address: data?.address ?? {},
      },
      onFinish: onFinish
    })
  }

  update({data = {}, onFinish = () => {}}) {
    serverPost({
      url: "user/update",
      data: {
        firstName: data?.firstName ?? "",
        lastName: data?.lastName ?? "",
        phone: data?.phone ?? "",
        // password: data?.password ?? "",
      },
      onFinish: onFinish
    })
  }

  login({ password, verifyData, onFinish = () => {} }) {
    serverPost({
      url: "user/login",
      data: { password, verifyData },
      onFinish: onFinish,
    });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new UserService();
